"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
var defaultTranslations = {
  back: "Back",
  months: "months",
  year: "year",
  years: "years",
  setSelfExclusion: "Set Self Exclusion",
  selfExcludedFor: "Self excluded for",
  selfExclusionMessage: "Self exclusion completely blocks access to low6. Please note that once you have set a self-exclusion period, it cannot be removed for the selected duration."
};
exports.defaultTranslations = defaultTranslations;